<template>
    <path fill-rule="evenodd" d="M13.237 24H.763c-.31 0-.587-.293-.705-.74-.118-.45-.053-.966.165-1.31L6.545 12 .223 2.05C.005 1.706-.06 1.19.058.74.176.292.454 0 .763 0h12.474c.42 0 .763.538.763 1.2v3.71c0 .663-.342 1.2-.763 1.2s-.667-.537-.667-1.2V2.255H2.425l5.738 8.895c.143.225.223.53.223.85 0 .317-.08.623-.223.848l-5.738 8.945H12.57v-2.885c0-.663.246-1.2.667-1.2.42 0 .763.537.763 1.2v3.89c0 .663-.342 1.2-.763 1.2z"/>
</template>

<script>
export default {
    name: 'previewSumIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 14 24');
    }
};
</script>
